import { Printer } from "lucide-react";

const W = 3.95, D = 1.5, H = 1.7, T = 0.45, M = 0.3;
const X0 = M + H, Y0 = M + H;
const total = { w: H * 2 + W + M * 2, h: H * 2 + D + M * 2 };

const Tab = ({ x, y, w, h, side }) => {
  const i = 0.15;
  const pts = side === "left"
    ? `${x + w},${y} ${x},${y + i} ${x},${y + h - i} ${x + w},${y + h}`
    : `${x},${y} ${x + w},${y + i} ${x + w},${y + h - i} ${x},${y + h}`;
  return <polygon points={pts} className="box-tab" />;
};

const WallText = ({ cx, cy, rotate, big, small }) => (
  <g transform={`translate(${cx} ${cy}) rotate(${rotate})`}>
    <text className="box-big" textAnchor="middle" y="-0.05">{big}</text>
    <text className="box-small" textAnchor="middle" y="0.28">{small}</text>
  </g>
);

export default function PrintDinnerBox() {
  return (
    <div className="pp-dcards" data-testid="print-dinner-box-page">
      <div className="pp-dcards-bar no-print">
        <p>Print on cardstock, cut the solid lines, fold the dashed lines, glue the gray tabs inside.</p>
        <button className="pp-primary" onClick={() => window.print()} data-testid="print-dinner-box-button"><Printer className="h-5 w-5" /> Print</button>
      </div>
      <div className="pp-box-sheet">
        <svg viewBox={`0 0 ${total.w} ${total.h}`} width={`${total.w}in`} height={`${total.h}in`} className="pp-box-svg" data-testid="dinner-box-template">
          <Tab x={X0 - T} y={M} w={T} h={H} side="left" />
          <Tab x={X0 + W} y={M} w={T} h={H} side="right" />
          <Tab x={X0 - T} y={Y0 + D} w={T} h={H} side="left" />
          <Tab x={X0 + W} y={Y0 + D} w={T} h={H} side="right" />
          <rect x={X0} y={M} width={W} height={H} className="box-wall back" />
          <rect x={X0} y={Y0 + D} width={W} height={H} className="box-wall front" />
          <rect x={M} y={Y0} width={H} height={D} className="box-wall side" />
          <rect x={X0 + W} y={Y0} width={H} height={D} className="box-wall side" />
          <rect x={X0} y={Y0} width={W} height={D} className="box-base" />
          <path d={`M${X0} ${Y0} h${W} M${X0} ${Y0 + D} h${W} M${X0} ${Y0} v${D} M${X0 + W} ${Y0} v${D}`} className="box-fold" />
          <path d={`M${X0} ${M} v${H} M${X0 + W} ${M} v${H} M${X0} ${Y0 + D} v${H} M${X0 + W} ${Y0 + D} v${H}`} className="box-fold" />
          <WallText cx={X0 + W / 2} cy={M + H / 2} rotate={0} big="NICE™ Dinner Questions" small="Pick a card, pass it on" />
          <WallText cx={X0 + W / 2} cy={Y0 + D + H / 2} rotate={180} big="Pick a card!" small="Devices away · everyone answers" />
          <WallText cx={M + H / 2} cy={Y0 + D / 2} rotate={-90} big="Gratitude" small="BurrHaus" />
          <WallText cx={X0 + W + H / 2} cy={Y0 + D / 2} rotate={90} big="Kindness" small="Counseling" />
          <image href="/acorn-t.png" x={X0 + W / 2 - 0.35} y={Y0 + D / 2 - 0.35} width="0.7" height="0.7" />
        </svg>
        <ol className="pp-box-steps">
          <li>Print on cardstock at 100% size (no “fit to page”).</li>
          <li>Cut along the solid outline, including around the gray tabs.</li>
          <li>Fold every dashed line so the printed side stays on the outside.</li>
          <li>Glue each gray tab to the inside of the side walls. Let it dry.</li>
          <li>Drop in your cut-out question cards and set it on the table!</li>
        </ol>
      </div>
    </div>
  );
}
